import React from 'react';
import { Grid, TextField, MenuItem, Box } from '@mui/material';
import { Student } from '@/types';
import { US_STATES } from '@/constants';
import { ContactMap } from './ContactMap';

interface ContactInfoSectionProps {
  values: Partial<Student>;
  onChange: (id: keyof Student, value: any) => void;
}

export const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  values,
  onChange
}) => {
  const handleChange = (field: keyof Student) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange(field, event.target.value);
  };

  const fullAddress = values.address ? 
    `${values.address}, ${values.city}, ${values.state} ${values.zipCode}` : 
    '';

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Address"
          value={values.address || ''}
          onChange={handleChange('address')}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="City"
          value={values.city || ''}
          onChange={handleChange('city')}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="State"
          value={values.state || ''}
          onChange={handleChange('state')}
          required
        >
          {US_STATES.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="ZIP Code"
          value={values.zipCode || ''}
          onChange={handleChange('zipCode')}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Primary Phone"
          value={values.primaryPhone || ''}
          onChange={handleChange('primaryPhone')}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Secondary Phone"
          value={values.secondaryPhone || ''}
          onChange={handleChange('secondaryPhone')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="email"
          label="Email"
          value={values.email || ''}
          onChange={handleChange('email')}
        />
      </Grid>

      {/* Map Section */}
      <Grid item xs={12}>
        <Box sx={{ mt: 2 }}>
          <ContactMap studentAddress={fullAddress} />
        </Box>
      </Grid>
    </Grid>
  );
};